import { render, staticRenderFns } from "./nudge-config.vue?vue&type=template&id=486960e9&"
import script from "./nudge-config.ts?vue&type=script&lang=ts&"
export * from "./nudge-config.ts?vue&type=script&lang=ts&"
import style0 from "./nudge-config.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports